module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-list"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.doWhatTemp != 'view'),
      expression: "doWhatTemp != 'view'"
    }],
    staticClass: "breadcrumb-bar"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/library/'
      }
    }
  }, [_vm._v("内容提供商")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(this.$route.query.cpid ? "编辑书籍" : "添加书籍"))])], 1)], 1), _vm._v(" "), _c('el-card', [_c('addBookBasicInfo', {
    attrs: {
      "basicInfo": _vm.basicInfo,
      "tagIds": _vm.tagIds,
      "doWhatTemp": _vm.doWhatTemp
    },
    on: {
      "brandChose": _vm.brandChoseHandle
    }
  }), _vm._v(" "), _c('div', [_c('addBookDetail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.liteMode),
      expression: "!liteMode"
    }],
    attrs: {
      "detailInfo": _vm.detailInfo,
      "tagList": _vm.tagList,
      "tagForDetail": _vm.tagForDetail,
      "doWhatTemp": _vm.doWhatTemp
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "20px 10px 20px 0"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addContent('ebook')
      }
    }
  }, [_vm._v(_vm._s(_vm.btnName) + "电子书内容")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "20px 10px 20px 10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addContent('audio')
      }
    }
  }, [_vm._v(_vm._s(_vm.btnName) + "音视频内容")]), _vm._v(" "), (this.$route.query.do == 'edit') ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "20px 10px 20px 0"
    },
    on: {
      "click": function($event) {
        return _vm.doNextStep('formCustom')
      }
    }
  }, [_vm._v("确定")]) : _vm._e(), _vm._v(" "), (this.$route.query.do == 'view') ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "20px 10px 20px 0"
    },
    on: {
      "click": function($event) {
        return _vm.doNextStep1('formCustom1')
      }
    }
  }, [_vm._v("确定")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-887410d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/book/addBook.vue
// module id = 718
// module chunks = 1